import { formatNumber, formatPercent, fromThousandths } from '@platform/design-system';

export type ValueScaleKind = 'money' | 'count' | 'ratio';

const TICK_FORMATS: Readonly<Record<ValueScaleKind, (value: number, locale: string) => string>> = {
  money: (value, locale) => formatNumber(Number(fromThousandths(value)), locale),
  count: (value, locale) => formatNumber(value, locale),
  ratio: (value, locale) => formatPercent(value, locale),
};

export const tickFormatOf =
  (kind: ValueScaleKind, locale: string) =>
  (value: number): string =>
    TICK_FORMATS[kind](value, locale);
